import * as React from "react";
import { ProposedProperty } from "../../../core";
import { PropertyDetails } from "../../../core/api/models/project";
import SortableList from "./SortableList";
import PropertyInformation from "./PropertyInformation";
import LocationSort from "./LocationSort";
import VersionSort from "./VersionSort";
import SortableMenuList from "./SortableMenuList";

enum sortTabs {
  manual = "manual",
  location = "location",
  version = "version",
}

const SortProperties: React.FunctionComponent<{
  requirementId?: string;
  proposedProperties: ProposedProperty[];
  onRemove: (propertys: PropertyDetails[]) => void;
  propertyDetails?: PropertyDetails[];
  onSelect: () => void;
  setSelectedProperties: (propertys: PropertyDetails[]) => void;
}> = (props) => {
  const [sortTab, setSortTab] = React.useState<sortTabs>(sortTabs.manual);

  const sortList = props.propertyDetails;

  const groupByList = sortList?.reduce((group: any, product: any) => {
    const { projectId } = product;
    group[projectId] = group[projectId] ?? [];
    group[projectId].push(product);
    return group;
  }, {});

  const setItems = async (items: any) => {
    props.setSelectedProperties([...(items || [])]);
  };

  const DragComponent = ({ item, index }: { item: any; index: number }) => {
    return (
      <PropertyInformation
        templates={item}
        index={index}
        propertyDetails={props.propertyDetails}
        onSelect={props.onSelect}
        onRemove={props.onRemove}
      />
    );
  };

  const setLocationItems = async (items: any) => {
    let properties: PropertyDetails[] = [];
    if (items) {
      for (const v in items) {
        if (items[v]) {
          properties = [
            ...(properties || []),
            ...(props.propertyDetails?.filter(
              (x) => x.cityLocName === items[v]
            ) || []),
          ];
        }
      }
    }

    props.setSelectedProperties(properties);
  };

  const seVersionItems = async (items: any) => {
    let properties: PropertyDetails[] = [];
    if (items) {
      for (const v in items) {
        if (items[v]) {
          properties = [
            ...(properties || []),
            ...(props.propertyDetails?.filter((x) =>
              Number(items[v]) === 0
                ? !x.proposalVersion || x.proposalVersion === 0
                : x.proposalVersion === Number(items[v])
            ) || []),
          ];
        }
      }
    }

    props.setSelectedProperties(properties);
  };

  const LocationDragComponent = ({
    item,
    index,
  }: {
    item: any;
    index: number;
  }) => {
    return (
      <LocationSort
        templates={item}
        index={index}
        propertyDetails={props.propertyDetails}
        onSelect={props.onSelect}
        onRemove={props.onRemove}
      />
    );
  };

  const VersionDragComponent = ({
    item,
    index,
  }: {
    item: any;
    index: number;
  }) => {
    return (
      <VersionSort
        templates={item}
        index={index}
        propertyDetails={props.propertyDetails}
        onSelect={props.onSelect}
        onRemove={props.onRemove}
      />
    );
  };

  const cityLocations = props.propertyDetails
    ?.map((x) => x.cityLocName)
    ?.filter((element) => {
      return element !== undefined;
    });

  const proposalVersions = props.propertyDetails
    ?.map((x) => x.proposalVersion || 0)
    ?.filter((element) => {
      return element !== undefined;
    });

  const cityLocNames = [...new Set(cityLocations || [])];

  const versions = [...new Set(proposalVersions || [])];

  return !!sortList?.length ? (
    <>
      <div className="mt-4 mb-4">
        <div className="d-flex align-items-center">
          <div className="text-nowrap font-md font-weight-semibold mr-2">
            Sort by
          </div>
          <div className="tabButton tabButton--variant d-flex text-center font-sm font-weight-semibold cursor-pointer">
            <div
              className={`col-auto tabButton__item  px-3 py-2 ss ${
                sortTab === sortTabs.manual
                  ? "tabButton__item--active"
                  : "text-gray-600"
              }`}
              onClick={() => setSortTab(sortTabs.manual)}
            >
              Manual
            </div>
            {!!cityLocNames?.length && (
              <div
                className={`col-auto tabButton__item flex-fill px-3 py-2 ${
                  sortTab === sortTabs.location
                    ? "tabButton__item--active"
                    : "text-gray-600"
                }`}
                onClick={() => setSortTab(sortTabs.location)}
              >
                Location
              </div>
            )}
            {!!versions?.filter((v) => v !== 0)?.length && (
              <div
                className={`col-auto tabButton__item px-3 py-2 text-nowrap ${
                  sortTab === sortTabs.version
                    ? "tabButton__item--active"
                    : "text-gray-600"
                }`}
                onClick={() => setSortTab(sortTabs.version)}
              >
                View by Proposal Version
              </div>
            )}
          </div>
        </div>
      </div>
      {groupByList && (
        <div className="row">
          {sortTab === sortTabs.location && (
            <div className="col-3 pt-5">
              <SortableMenuList
                items={cityLocNames}
                setItems={setLocationItems}
                component={LocationDragComponent}
                length={cityLocNames?.length}
              />
            </div>
          )}
          {sortTab === sortTabs.version && (
            <div className="col-3 pt-5">
              <SortableMenuList
                items={versions}
                setItems={seVersionItems}
                component={VersionDragComponent}
                length={versions?.length}
              />
            </div>
          )}
          <div className={sortTab !== sortTabs.manual ? "col-9 " : "col-12"}>
            <div className="table-responsive shortListProperty-Table">
              <table className="table w-100 text-nowrap">
                <tr className="font-sm text-gray-600">
                  <th
                    className="py-3 border-bottom"
                    style={{
                      maxWidth: "40px",
                      minWidth: "40px",
                      width: "40px",
                    }}
                  ></th>
                  <th
                    className="py-3 border-bottom"
                    style={{
                      maxWidth: "90px",
                      minWidth: "90px",
                      width: "90px",
                    }}
                  ></th>
                  <th
                    className="py-3 border-bottom font-weight-semibold "
                    style={{
                      minWidth: "290px",
                      maxWidth: "290px",
                      width: "290px",
                    }}
                  >
                    Property
                  </th>
                  <th
                    className="py-3 border-bottom font-weight-semibold px-2  text-left"
                    style={{
                      minWidth: "194px",
                      maxWidth: "194px",
                      width: "194px",
                    }}
                  >
                    Version
                  </th>
                  <th
                    className="py-3 border-bottom font-weight-semibold px-2 text-left"
                    style={{
                      minWidth: "120px",
                      maxWidth: "120px",
                      width: "120px",
                    }}
                  >
                    Square feet area
                  </th>
                  <th
                    className="py-3 border-bottom font-weight-semibold px-2 text-left"
                    style={{
                      minWidth: "200px",
                      maxWidth: "200px",
                      width: "200px",
                    }}
                  >
                    Developer
                  </th>

                  <th className="py-3 border-bottom font-weight-semibold px-2 text-left">
                    Added Units
                  </th>
                  <th className="py-3 border-bottom font-weight-semibold px-2"></th>
                </tr>
                {/* {[...Array(3)].map((item, index) => { */}
                <tr>
                  <td colSpan={8}>
                    <SortableList
                      items={groupByList}
                      setItems={setItems}
                      component={DragComponent}
                      length={groupByList?.length}
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div className="d-flex justify-content-end my-3 pt-3">
              <div>
                <button
                  type="button"
                  onClick={props.onSelect}
                  className="btn bg-primary select-prop-bt font-normal font-weight-bold text-white"
                  disabled={!props.propertyDetails?.length}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <></>
  );
};

export default SortProperties;
